module.exports = __webpack_public_path__ + "static/media/share.ccef54cf.svg";